module.exports = __webpack_public_path__ + "static/fonts/Helvetica-Regular.0f8e7fb.ttf";